import * as companyApi from '../../api/company-api';
import { IAccountUser } from '../../models/account-user';
import { ICompanyAccount } from '../../models/company-account';
import { IBucket } from '../../models/prostatic';
import { IResult } from '../../models/result-models';
import { IRole } from '../../models/role';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_COMPANY_ACCOUNT_CONTACTS_SUCCESS =
    'LOAD_COMPANY_ACCOUNT_CONTACTS_SUCCESS';
export const LOAD_COMPANY_ACCOUNT_USERS_SUCCESS =
    'LOAD_COMPANY_ACCOUNT_USERS_SUCCESS';

export const LOAD_COMPANY_ACCOUNTS_SUCCESS = 'LOAD_COMPANY_ACCOUNTS_SUCCESS';
export const LOAD_COMPANY_BUCKETS_SUCCESS = 'LOAD_COMPANY_BUCKETS_SUCCESS';
export const LOAD_COMPANY_ROLES_SUCCESS = 'LOAD_COMPANY_ROLES_SUCCESS';

// Actions
export const loadCompanyAccountsSuccess = (
    payload: IResult<ICompanyAccount[]>
) => ({
    type: LOAD_COMPANY_ACCOUNTS_SUCCESS,
    payload,
});

export const loadCompanyBucketsSuccess = (payload: IResult<IBucket[]>) => ({
    type: LOAD_COMPANY_BUCKETS_SUCCESS,
    payload,
});

export const loadCompanyRolesSuccess = (payload: IResult<IRole[]>) => ({
    type: LOAD_COMPANY_ROLES_SUCCESS,
    payload,
});

export const loadCompanyAccountContactsSuccess = (
    payload: IResult<IAccountUser[]>
) => ({
    type: LOAD_COMPANY_ACCOUNT_CONTACTS_SUCCESS,
    payload,
});

export const loadCompanyAccountUsersSuccess = (
    payload: IResult<IAccountUser[]>
) => ({
    type: LOAD_COMPANY_ACCOUNT_USERS_SUCCESS,
    payload,
});

// Thunks
export const loadCompanyAccounts = (id?: string) => {
    return async (dispath: any) => {
        try {
            dispath(beginApiCall());
            const result = await companyApi.getCompanyAccounts(id);
            dispath(loadCompanyAccountsSuccess(result));
        } catch (error) {
            dispath(apiCallError(error));
        }
    };
};

export const loadCompanyBuckets = (id?: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await companyApi.getCompanyBuckets(id);
            dispatch(loadCompanyBucketsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};

export const loadCompanyRoles = (id?: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await companyApi.getCompanyRoles(id);
            dispatch(loadCompanyRolesSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};

export const loadCompanyAccountPreferences = (id?: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());

            await Promise.all([
                companyApi.getCompanyAccountUsers(id),
                companyApi.getCompanyRoles(id),
            ]);
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};

export const loadAccountUsers = (id?: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await companyApi.getCompanyAccountUsers(id);
            dispatch(loadCompanyAccountUsersSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};

export const loadAccountContacts = (id?: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await companyApi.getCompanyAccountContacts(id);
            dispatch(loadCompanyAccountContactsSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};
